import { Component, OnInit } from "@angular/core";

import { TaxCardIncomeType, TaxCardType } from "@salaxy/core";
// HACK: Remove this dependency to Inonic components.
import { NavController, NavParams } from "ionic-angular";
import { ITaxCardSettings } from "./taxcardSettings";

import { SalaxyContext } from "../../../services/index";

/* tslint:disable */
/* TODO: Waiting for rewrite / final implementation */

@Component({
    selector: "salaxy-current-tax-card",
    template: ``,
})
export class NgTaxcardComponent implements OnInit {

    public blankTaxCard: any = {};

    public isInEditMode: boolean = false;

    public previousSalariesPaid: number;

    public today = new Date();

    public todayISO = this.today.toISOString();

    public yearsLastDay = new Date(this.today.getFullYear(), 11, 31);

    public yearsLastDayISO = this.yearsLastDay.toISOString();

    public taxCardUISettings: ITaxCardSettings = {
        disableMainTaxPercent: false,

        requireMainTaxPercent: false,

        requireAdditionalTaxPercent: false,
        requireIncomeLimit: false,
        requirePreviousSalariesPaid: false,
        requireStepsTaxPercent3: false,
        requireTaxCardStartDate: false,
        requireTaxYear: false,

        showAdditionalTaxPercent: false,
        showIncomeLimit: false,
        showMainTaxPercent: false,
        showOtherTaxCardInfo: false,
        showPreviousSalariesPaid: false,
        showTaxCardStartDate: false,
        showTaxYear: false,
    };

    constructor(
        protected context: SalaxyContext,
        protected navCtrl: NavController,
        protected navParams: NavParams,
    ) {
    }

    /** Initializes the component */
    public ngOnInit() {
        this.blankTaxCard = this.context.taxCards.getBlank();
    }

    /**
     * Adds previous salaries inputed through UI to the blank tax card
     */
    public addPreviouslyPaidSalaries() {
        const currentYear = new Date().getFullYear();
        this.blankTaxCard.incomeLog[0] = {
            description: "Previous salaries added from tax card component UI",
            endDate: new Date(),
            id: null,
            income: this.previousSalariesPaid,
            startDate: new Date(currentYear, 1, 1),
            tax: 0,
            type: TaxCardIncomeType.PreviousEmployerSalaries,
        };
    }

    /**
     * Updates visibility and requiredness of tax card related fields based on tax card selection
     */
    public updateTaxCardFieldVisibility(clearFieldValues?: boolean) {
        if (this.blankTaxCard != null) {
            switch (this.blankTaxCard.card.type) {
                case TaxCardType.Example:
                    this.taxCardUISettings = {
                    };
                    break;
                case TaxCardType.NoTaxCard:
                    this.taxCardUISettings = {
                        disableMainTaxPercent: true,
                        requireMainTaxPercent: true,
                        showMainTaxPercent: true,
                    };
                    if (clearFieldValues) {
                        this.blankTaxCard.card.taxPercent = 60;
                        this.blankTaxCard.card.taxPercent2 = null;
                        this.blankTaxCard.card.incomeLimit = null;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = null;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = null;
                    }
                    break;
                case TaxCardType.SideIncome:
                    this.taxCardUISettings = {
                        requireMainTaxPercent: true,
                        showMainTaxPercent: true,
                        showTaxYear: true,
                    };
                    if (clearFieldValues) {
                        this.blankTaxCard.card.taxPercent = 40;
                        this.blankTaxCard.card.taxPercent2 = null;
                        this.blankTaxCard.card.incomeLimit = null;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = null;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = null;
                    }
                    break;
                case TaxCardType.TaxCardA:
                    this.taxCardUISettings = {
                        requireAdditionalTaxPercent: true,
                        requireIncomeLimit: true,
                        requireMainTaxPercent: true,
                        requireTaxCardStartDate: true,

                        showAdditionalTaxPercent: true,
                        showIncomeLimit: true,
                        showMainTaxPercent: true,
                        showPreviousSalariesPaid: true,
                        showTaxCardStartDate: true,
                    };
                    if (clearFieldValues) {
                        this.blankTaxCard.card.taxPercent = null;
                        this.blankTaxCard.card.taxPercent2 = null;
                        this.blankTaxCard.card.incomeLimit = null;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = null;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = null;
                    }
                    break;
                case TaxCardType.TaxCardB:
                    this.taxCardUISettings = {
                        requireAdditionalTaxPercent: true,
                        requireIncomeLimit: true,
                        requireMainTaxPercent: true,

                        showAdditionalTaxPercent: true,
                        showIncomeLimit: true,
                        showMainTaxPercent: true,
                        showPreviousSalariesPaid: true,
                        showTaxYear: true,
                    };
                    if (clearFieldValues) {
                        this.blankTaxCard.card.taxPercent = null;
                        this.blankTaxCard.card.taxPercent2 = null;
                        this.blankTaxCard.card.incomeLimit = null;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = null;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = null;
                    }
                    break;
                case TaxCardType.Freelancer:
                    this.taxCardUISettings = {
                        requireMainTaxPercent: true,
                        showMainTaxPercent: true,
                        showTaxYear: true,
                    };
                    if (clearFieldValues) {
                        this.blankTaxCard.card.taxPercent = null;
                        this.blankTaxCard.card.taxPercent2 = null;
                        this.blankTaxCard.card.incomeLimit = null;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = null;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = null;
                    }
                    break;
                case TaxCardType.Steps:
                    this.taxCardUISettings = {
                        requireStepsTaxPercent3: true,
                        showOtherTaxCardInfo: true,
                        showPreviousSalariesPaid: true,
                    };
                    if (clearFieldValues) {
                        // Income limits for year 2017
                        this.blankTaxCard.card.incomeLimit = 10300;
                        this.blankTaxCard.card.stepsCardIncomeLimit2 = 17650;

                        this.blankTaxCard.card.taxPercent = 0;
                        this.blankTaxCard.card.taxPercent2 = 10.5;
                        this.blankTaxCard.card.stepsCardTaxPercent3 = 40;
                    }
                    break;
            }
        }

    }

    public save() {
        if (this.context.session.isAuthenticated) {
            this.context.taxCards.saveCurrent();
        } else {
            // HACK: This needs to be alerted to the user.
            this.context.taxCards.list.splice(0, 0, this.blankTaxCard);
            this.blankTaxCard = null;
        }
        this.navCtrl.pop();
    }

}
